import { withInstall } from '../../utils/install';
import Card from './index.vue';

export const IvueCard = withInstall(Card);
export default IvueCard;

export * from './index.vue';
